import { css as _css } from "@emotion/core";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as styles from './allhomes-sticky-footer.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var getScrollPos = () => {
  var doc = document.documentElement;
  return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
};
var getElementTop = element => {
  if (!element) {
    return 0;
  }
  var bodyRect = document.body.getBoundingClientRect();
  var elemRect = element.getBoundingClientRect();
  return elemRect.top - bodyRect.top;
};
var getViewportHeight = () => Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
var StickyFooter = _ref => {
  var children = _ref.children,
    limitRef = _ref.limitRef;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isVisible = _useState2[0],
    setVisible = _useState2[1];
  var handleScroll = () => {
    var scrollPos = getScrollPos();
    var maxScrollPosition = limitRef ? getElementTop(limitRef.current) - getViewportHeight() : -1;
    var hasScrolled = scrollPos > 0;
    var maxScrollReached = maxScrollPosition !== -1 && maxScrollPosition < scrollPos;
    var newVisibleState = hasScrolled && !maxScrollReached;
    if (isVisible !== newVisibleState) {
      setVisible(newVisibleState);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleScroll);
    };
  });
  return ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([styles.stickyFooter, isVisible && styles.visible])
  }, children);
};
StickyFooter.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  limitRef: PropTypes.shape({
    current: PropTypes.elementType
  })
};
StickyFooter.defaultProps = {
  limitRef: undefined
};
export default StickyFooter;